"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CommentType = void 0;
/** 评论类型 */
const CommentType = exports.CommentType = {
  /** 跟进 */
  FollowUp: 0,
  /** 汇报 */
  Report: 1
};